import _ from 'lodash'
import React, { PureComponent } from "react"
import PropTypes from "prop-types"

export default class MqSubParameters extends PureComponent {

  static propTypes = {
    items: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired
  };

  getFieldDescription(fieldProps) {
    const fieldDescription = fieldProps.description || fieldProps.title

    if (!fieldDescription || !fieldDescription.match(/\r?\n/)) {
      return this.formatDescription(fieldDescription);
    }

    // replace unix/windows newline with wrapped div
    return (
      <div className="param-chart__val-desc">
        {fieldDescription.split(/\r?\n/).map((d, i) => <div key={i}>{this.formatDescription(d, false)}</div>)}
      </div>
    );
  }

  formatDescription(desc, wrapReturn = true) {
    if (_.isEmpty(desc)) {
      return wrapReturn ? <div className="param-chart__val-desc"/> : desc;
    }

    const regex = new RegExp(/Enum: \[[^)]+?\]/g);
    const matches = desc.match(regex);

    if (_.isEmpty(matches)) {
      return wrapReturn ? <div className="param-chart__val-desc">{desc}</div> : desc;
    }

    const enumEls = matches.map((m, i) => {
      const pieces = m.slice(m.indexOf('[') + 1, -1).split(',');

      return (
        <span key={i}>
          Enum:
          {pieces.map((p, j) => (<span className="param-chart__enum-block param-chart__enum-block--alt" key={j}>"{p.trim()}"</span>))}
        </span>
      )
    });

    return (
      <div className="param-chart__val-desc">
        {_.reduce(desc.split(regex), (descPieces, dPiece, index) => ([
          ...descPieces,
          dPiece,
          ...!_.isUndefined(enumEls[index]) && [enumEls[index]]
        ]), [])}
      </div>
    );
  }

  render() {
    let {
      items: {
        properties,
        required
      },
      getComponent
    } = this.props
    const MqSubParams = getComponent("mqsubparameters")

    if (_.isEmpty(properties)) {
      return null;
    }

    return (
      <div className="param-chart__sub-param">
        {_.reduce(properties, (renderArr, fieldProps, fieldName) => {

          return [
            ...renderArr,
            (
              <div className="grid param-chart" key={fieldName}>
                <div className="col__sm-6 param-chart__key">
                  {fieldName}
                  {required.indexOf(fieldName) >= 0 &&
                    <span className="parameter__name required"> *</span>
                  }
                </div>
                <div className="col__sm-6 param-chart__val">
                  <div className="param-chart__val-type">{fieldProps.type}{fieldProps.format && ` <${fieldProps.format}>`}</div>
                  {this.getFieldDescription(fieldProps)}
                  {_.get(fieldProps, 'items.type', '') === 'object' &&
                    <MqSubParams
                      items={fieldProps.items}
                      getComponent={getComponent}
                    />
                  }
                </div>
              </div>
            )
          ]
        }, [])}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/machineq/components/MqSubParameters.jsx